var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flip-card col-lg-3 col-md-6 mt-4" }, [
    _c(
      "div",
      {
        staticClass: "flip-card-inner",
        class: _vm.rotateCard ? "card-rotate" : ""
      },
      [
        _c(
          "router-link",
          {
            staticClass: "text-decorator",
            attrs: {
              event:
                _vm.option.needSelectedStudent && !_vm.hasSelectedStudent
                  ? ""
                  : "click",
              to: _vm.option.route
            },
            nativeOn: {
              click: function($event) {
                $event.preventDefault()
                return _vm.goToRoute(_vm.option.route)
              }
            }
          },
          [
            _c("div", { staticClass: "flip-card-front" }, [
              _c("div", { staticClass: "col-xs-7 py-2" }, [
                _c("img", {
                  staticClass: "rounded-circle",
                  attrs: { src: _vm.showImage(_vm.option.mainImage) }
                }),
                _c("h3", { staticClass: "card-front-title" }, [
                  _vm._v(" " + _vm._s(_vm.option.title) + " ")
                ]),
                _c("p", { staticClass: "px-4 card-front-p" }, [
                  _vm._v(" " + _vm._s(_vm.option.description) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "flip-card-back" }, [
              _c("div", { staticClass: "text-right" }, [
                _c("img", {
                  staticClass: "rounded-circle",
                  attrs: { src: _vm.showImage(_vm.option.hoverImage) }
                })
              ]),
              _c("h3", { staticClass: "card-back-title" }, [
                _vm._v(" " + _vm._s(_vm.option.title) + " ")
              ]),
              _c("p", { staticClass: "card-back-p px-4 pb-2" }, [
                _vm._v(" " + _vm._s(_vm.option.detail) + " ")
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }